import Container from "../../views/layouts/Container";

export default Container.extend`
  padding-top: 64px;
`


// WEBPACK FOOTER //
// ./src/components/templates/signin/SigninLayout.js